import React from 'react'
import AchieveBottom from './AchieveBottom'
import './AchieveCss.css'
import AchieveTop from './AchieveTop'

const Achieve = () => {
  return (
    <section className="achieve-container">
      <AchieveTop />
      <AchieveBottom />
    </section>
  )
}

export default Achieve